export const isBlank = (str: string): boolean => !str || /^\s*$/.test(str);
